<template>
    <UsersList/>
</template>

<script>

import UsersList from '../../components/users/UsersList';

export default {
  components: {
    UsersList,
  },
};
</script>
